import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  AccordionHeaderContent,
  AccordionItemContentType,
  DrugItem
} from 'src/api/types';
import cn from 'classnames';
import { GTAGPrefix } from 'src/hooks/useGTAG';
import trns from '../../trns';
import { generateDrugPageNavigationLinks } from '../../utils';
import AccordionDefaultBody from '../../../../shared-components/Accordion/AccordionDefaultBody';
import AccordionDefaultHeader from '../../../../shared-components/Accordion/AccordionDefaultHeader';
import Accordion from '../../../../shared-components/Accordion/Accordion';

interface Props {
  drug: DrugItem;
  thirdCategoryName: string;
  gtagPrefix?: GTAGPrefix;
}

const InstructionsTabContent: FC<Props> = ({ drug, gtagPrefix }) => {
  const drugPageNavigationLinks = generateDrugPageNavigationLinks(drug);

  return (
    <div className="flex flex-col w-full">
      <div className="text-darkBlue fs-body-reg uppercase mb-5">
        <h2>
          <FormattedMessage
            {...trns.instructionsFor}
            values={{ drugName: drug?.name }}
          />
        </h2>
      </div>
      <p className="fs-body-reg text-shuttleGray pt-4 lm:mb-11 mb-0">
        <FormattedMessage {...trns.instructionDisclaimer} />
      </p>
      <div className="flex pt-4">
        <Accordion
          accordionList={drugPageNavigationLinks.map((group) => ({
            header: {
              id: group.id,
              title: group.name
            },
            body: [
              <div
                key={group?.id}
                className={cn(
                  'fs-caption-reg text-tundora compendium-innerHtmlStyling bg-white rounded-b-xl',
                  'xs:w-1/2 sm:w-2/3 xs:rounded-b-0 xs:pb-0 xs:pr-0'
                )}
                dangerouslySetInnerHTML={{ __html: group.value as string }}
              />
            ]
          }))}
          renderItem={(content) => <AccordionDefaultBody content={content} />}
          classNameButton={'pt-3.5 pb-3.5 border-b border-periwinkleGray'}
          gtagPrefix={gtagPrefix}
          renderHeader={(
            header: AccordionHeaderContent,
            productsList: AccordionItemContentType[],
            active: false
          ) => (
            <AccordionDefaultHeader
              header={header}
              productsList={productsList}
              active={active}
            />
          )}
        />
      </div>
    </div>
  );
};

export default InstructionsTabContent;
